import { registerScript, setHashFunction } from "./scriptLoader";

const root = window;

const isModern = root.Map && root.Symbol;

setHashFunction(() => qd.formsViewer.workerBundleHash);

registerScript(
    'sharePoint',
    {
        url: '/bundles/sharePointLibraries2.js',
    },
);

registerScript(
    'polyfill',
    {
        url: '/Scripts/Libraries/IE/babel-polyfill.min.js',
    },
);

registerScript(
    'htmldiff-tnwinc',
    {
        url: '/Scripts/Libraries/htmldiff-tnwinc.js',
        get: () => root.htmldiff,
    }
);

registerScript(
    'htmldiff',
    {
        url: `/scripts/libraries/${isModern ? '' : 'IE/'}htmldiff.min.js`,
        get: () => root.HtmlDiff.default.execute,
        dependencies: isModern ? [] : ['polyfill'],
    },
);